export function verif(rows, month, AN) {
  const moisTextuel = ["jan", "fev", "mars", "avril", "mai", "juin", "juillet", "aout", "sept", "oct", "nov", "dec"];
  const moisStr = moisTextuel[month - 1];
  const anStr = AN.toString().slice(-2);
  const formeDate = `${moisStr}-${anStr}`;

  let array = [];
  let colDesignation = 0;
  let colCode = 0;
  let colPrix = 0;
  let colMois = {};
  let colTotal = -1;
  let head = false;
  let test = false;

  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    const row = rows[rowIndex];
    const lowercaseRow = row.map(val => val?.toString().toLowerCase().trim() || "");

    // ✅ Détection de l’entête
    if (!head &&
      lowercaseRow.includes("code") &&
      lowercaseRow.includes("article") &&
      lowercaseRow.includes("pght") &&
      lowercaseRow.some(m => moisTextuel.includes(m))
    ) {
      colCode = lowercaseRow.indexOf("code");
      colDesignation = lowercaseRow.indexOf("article");
      colPrix = lowercaseRow.indexOf("pght");

      // Sauvegarde des index pour chaque mois
      moisTextuel.forEach(mois => {
        const idx = lowercaseRow.indexOf(mois);
        if (idx !== -1) colMois[mois] = idx;
      });

      // Colonne TOTAL
      colTotal = lowercaseRow.indexOf("total");

      head = true;
      test = true;
      continue;
    }

    if (!head) continue;

    const code = row[colCode];
    const designation = row[colDesignation];

    if ((typeof code === 'string' && code.trim() !== "") ||
      (typeof code === 'number' && !isNaN(code))) {

      let dataMois = {};
      Object.keys(colMois).forEach(mois => {
        dataMois[mois] = row[colMois[mois]] ?? 0;
      });

      array.push({
        designation: designation,
        idProduit: null,
        code: code,
        pght: row[colPrix] ?? 0,
        ...dataMois,
        total: colTotal !== -1 ? row[colTotal] ?? 0 : 0
      });
    }
  }
  console.log(array)
  return { array: array, test: test };
}
